import * as React from 'react';
import { Box } from '@mui/material';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { getTemplateUserGenerationsById } from '../../utils/templatesApi';

dayjs.extend(relativeTime);

export default function Templates({ Options, loading, value }) {

  function Row(props) {
    const { template } = props;
    const [open, setOpen] = React.useState(false);
    const [details, setDetails] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const handleToggle = async () => {
      const nextOpen = !open;
      setOpen(nextOpen);
      const filters = {
        startDate: value?.[0] ? dayjs(value[0]).toISOString() : undefined,
        endDate: value?.[1] ? dayjs(value[1]).toISOString() : undefined,
      };

      if (nextOpen && details.length === 0) {
        setLoading(true);
        try {
          const result = await getTemplateUserGenerationsById(
            template?.templateId,
            filters,
          );
          setDetails(result || []);
        } catch (err) {
          console.error(
            'Error fetching details for user:',
            template?.templateId,
            err,
          );
        } finally {
          setLoading(false);
        }
      }
    };

    return (
      <React.Fragment>
        <TableRow>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={handleToggle}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {template?.['template.name']}
          </TableCell>
          <TableCell align="right">{template?.generatedCount || 0}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                {loading ? (
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    <CircularProgress size={24} />
                  </Box>
                ) : (
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          User Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Category Name
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                          Generated Count{' '}
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                          Possible Templates
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {details?.map((user) => (
                        <TableRow key={user.userId}>
                          <TableCell>{user?.['user.first_name']}</TableCell>
                          <TableCell>{user?.["template.category.category_name"]}</TableCell>
                          <TableCell align="right">
                            {user?.generatedCount || 0}
                          </TableCell>
                          <TableCell align="right">
                            {user?.['template.possibleTemplates'] || 0}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '75vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ minWidth: '80vw', maxHeight: '75vh', overflow: 'auto' }}
        >
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow
                sx={{ position: 'sticky', top: 0, backgroundColor: '#fff' }}
              >
                <TableCell />
                <TableCell sx={{ fontWeight: 'bold' }}>Template Name</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                  Total Count{' '}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Options?.map((template) => (
                <Row key={template.templateId} template={template} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
